export default {"src":"/_next/static/media/deez.135b6c33.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};